import { render, staticRenderFns } from "./Matchings.vue?vue&type=template&id=653e698c&"
import script from "./Matchings.vue?vue&type=script&lang=js&"
export * from "./Matchings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports